import { render, staticRenderFns } from "./yx-result-pay.vue?vue&type=template&id=661ec34c&"
import script from "./yx-result-pay.vue?vue&type=script&lang=js&"
export * from "./yx-result-pay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports